import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api, apiPage } from '@/lib/api';
import type { Category, Division, ProductCard, ProductDetail } from '@/types/api';

export const DIVISION_PATH: Record<Division, string> = { APPAREL: '/apparel', SPORTS: '/sports-goods' };

export function useCategories(division?: Division) {
  return useQuery({
    queryKey: ['categories', division ?? 'all'],
    queryFn: () => api<Category[]>('/categories', { query: { division } }),
    staleTime: 5 * 60_000,
  });
}

export function useProducts(params: { division?: Division; category?: string; featured?: boolean; page?: number; pageSize?: number }) {
  return useQuery({
    queryKey: ['products', params],
    queryFn: () => apiPage<ProductCard>('/products', { query: params }),
    placeholderData: keepPreviousData,
    staleTime: 60_000,
  });
}

export function useProduct(slug: string | undefined) {
  return useQuery({
    queryKey: ['product', slug],
    queryFn: () => api<ProductDetail>(`/products/${encodeURIComponent(slug!)}`),
    enabled: Boolean(slug),
    staleTime: 60_000,
  });
}
